// 活动枚举
export const ACTIVITY_TYPE = {
  1: { label: '满减活动', value: 1 },
  2: { label: '满折活动', value: 2 },
  3: { label: '满送活动', value: 3 }
}
